import { render, staticRenderFns } from "./dishForm.vue?vue&type=template&id=b2285c36&scoped=true"
import script from "./dishForm.vue?vue&type=script&lang=js"
export * from "./dishForm.vue?vue&type=script&lang=js"
import style0 from "./dishForm.vue?vue&type=style&index=0&id=b2285c36&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2285c36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2285c36')) {
      api.createRecord('b2285c36', component.options)
    } else {
      api.reload('b2285c36', component.options)
    }
    module.hot.accept("./dishForm.vue?vue&type=template&id=b2285c36&scoped=true", function () {
      api.rerender('b2285c36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/goodsManage/dishForm.vue"
export default component.exports